/**
 * TPL Collection Infinite Scroll
 * IntersectionObserver-based pagination for collection grids.
 * Fetches next page, appends products, observes sentinel for next load.
 */

(function () {
  'use strict';

  var grid = document.getElementById('tpl-product-grid');
  var sentinel = document.getElementById('tpl-infinite-sentinel');
  var loader = document.getElementById('tpl-infinite-loader');
  var endMsg = document.getElementById('tpl-infinite-end');

  if (!grid || !sentinel) return;

  // Module-scope observer ref so cleanup hooks below can disconnect it on
  // pagehide / section unload (grill v2 #30).
  var observer = null;

  function tplInfiniteCleanup() {
    if (observer) {
      try { observer.disconnect(); } catch (_) {}
      observer = null;
    }
  }

  function isSameOrigin(url) {
    try {
      return new URL(url, window.location.href).origin === window.location.origin;
    } catch (_) { return false; }
  }

  var nextUrlEl = grid.querySelector('[data-tpl-next-url]');
  var nextUrl = nextUrlEl ? nextUrlEl.getAttribute('data-tpl-next-url') : null;
  if (nextUrl && !isSameOrigin(nextUrl)) nextUrl = null;
  var loading = false;

  function showLoader() {
    if (loader) {
      loader.style.display = '';
      loader.classList.add('is-loading');
    }
  }

  function hideLoader() {
    if (loader) {
      loader.style.display = 'none';
      loader.classList.remove('is-loading');
    }
  }

  function showEnd() {
    if (endMsg) endMsg.style.display = '';
    hideLoader();
  }

  function fetchNextPage() {
    if (loading || !nextUrl) return;
    loading = true;
    showLoader();

    fetch(nextUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('tpl-product-grid');

        if (newGrid) {
          var items = newGrid.querySelectorAll('.tpl-cpg__item');
          items.forEach(function (item, i) {
            item.style.opacity = '0';
            item.style.transform = 'translateY(16px)';
            grid.appendChild(item);

            // Fix 2026-10-05: appended cards still carry deferred hover images.
            // In room view they are the visible image, so hydrate on arrival or
            // the new rows land blank. No-op while the shopper is on Artwork.
            if (window.TPLHydrateRoomImages) window.TPLHydrateRoomImages(item);

            setTimeout(function () {
              item.style.transition = 'opacity 0.4s ease, transform 0.4s ease';
              item.style.opacity = '1';
              item.style.transform = 'translateY(0)';
            }, i * 60);
          });

          // Remove stale next-url marker from current grid
          var oldMarker = grid.querySelector('[data-tpl-next-url]');
          if (oldMarker) oldMarker.remove();

          // Check for next page
          var newNextEl = newGrid.querySelector('[data-tpl-next-url]');
          if (newNextEl) {
            var candidate = newNextEl.getAttribute('data-tpl-next-url');
            nextUrl = isSameOrigin(candidate) ? candidate : null;
          } else {
            nextUrl = null;
            showEnd();
            observer.unobserve(sentinel);
          }
        }

        hideLoader();
        loading = false;
      })
      .catch(function (err) {
        console.error('TPL Infinite Scroll: fetch error', err);
        hideLoader();
        loading = false;
      });
  }

  // Observe sentinel 300px before it enters viewport
  observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && nextUrl && !loading) {
          fetchNextPage();
        }
      });
    },
    { rootMargin: '0px 0px 300px 0px' }
  );

  observer.observe(sentinel);

  // Hide loader initially if there are more pages
  if (nextUrl) {
    hideLoader();
  } else {
    // No pagination — hide both loader and sentinel
    hideLoader();
    observer.unobserve(sentinel);
  }

  // TPL patch 2026-04-18 (grill v2 #30) — BEGIN
  // Disconnect on BFCache eviction so observer doesn't leak into the next
  // page navigation. Also disconnect when this section is reloaded by the
  // theme editor, scoped via contains(grid) so unrelated section reloads
  // don't tear us down.
  window.addEventListener('pagehide', tplInfiniteCleanup, { once: true });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.contains && e.target.contains(grid)) {
      tplInfiniteCleanup();
    }
  });
  // TPL patch 2026-04-18 (grill v2 #30) — END
})();
